/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectToken } from '@/redux';
import { setAccessToken } from '@/utilities';

export const CredentialProvider = ({ children }: { children: any }) => {
  const token = useSelector(selectToken);
  useEffect(() => {
    setAccessToken(token);
  }, [token]);

  return children;
};
